import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Encaixa la vista a tots els destinos en comptes de centrar-la a la
// mitjana de les seves coordenades: amb destinos allunyats (p.ex.
// Barcelona + Costa Brava) la mitjana cau en un punt geogràfic buit
// entremig (Vallès Oriental), no a cap destí real.
const AjustaVista = ({ bounds, center, zoom }) => {
    const map = useMap();

    useEffect(() => {
        if (bounds.length > 1) {
            map.fitBounds(bounds, { padding: [30, 30] });
        } else if (bounds.length === 1) {
            map.setView(bounds[0], zoom);
        } else {
            map.setView(center, zoom);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

const Mapa = ({ destinos, elementosweb, config, lang }) => {
    let results = [];

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    var centrolat = 0;
    var centrolong = 0;
    const bounds = [];

    destinos.forEach((undestino, index) => {
        centrolat += undestino.latitud;
        centrolong += undestino.longitud;
        bounds.push([undestino.latitud, undestino.longitud]);

        results = results.concat(
            <Marker position={[undestino.latitud, undestino.longitud]} key={index}>
                <Popup>
                    <a href={"/" + preidioma + t("apartamentos") + "-" + undestino.laurl}>{undestino.elnombre}</a>
                </Popup>
            </Marker>
        );
    })
    centrolat = centrolat / destinos.length;
    centrolong = centrolong / destinos.length;

    return (
        config.activa_mapa_web ?
            <div className="pt-4 pb-5 mt-4 mapa potblur bhh-mapa">

                <div className="bhh-section__head">
                    <span className="bhh-eyebrow">{t("Ubicación")}</span>
                    <h2 className="text-center">{elementosweb.titulo_mapa ? elementosweb.titulo_mapa[lang] : ""}</h2>
                    <p className="text-center">{elementosweb.subtitulo_mapa ? elementosweb.subtitulo_mapa[lang] : ""}</p>
                </div>

                <div className="bhh-mapa__frame">
                    <MapContainer center={[centrolat, centrolong]} zoom={config.zoom_mapa_web} scrollWheelZoom={false}>
                        <AjustaVista bounds={bounds} center={[centrolat, centrolong]} zoom={config.zoom_mapa_web} />
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {results}
                    </MapContainer>
                </div>
            </div>
            :
            <></>
    );
}

export default Mapa;
